import TopCompaniesRestrictionWrapper from './TopCompaniesRestrictionWrapper';

export default TopCompaniesRestrictionWrapper;
